<template>
    <div class="main-block request-management ">
        <Breadcrumbs />
        <!-- Header Section -->
        <div class="header">
            <h4>{{ $t('title.ApiLogs') }}</h4>
            <b-button variant="primary" @click="goBack">
                {{ $t('title.goBack') }}
            </b-button>
        </div>

        <!-- Main Content with Scrollable Details -->
        <b-row v-if="isLoading" class="justify-content-center my-4 scrollable-container">
            <b-spinner label="Loading..."></b-spinner>
        </b-row>

        <b-row v-else-if="errorMessage" class="justify-content-center my-4 text-danger">
            {{ errorMessage }}
        </b-row>

        <b-row v-else class="details-container">
            <b-col cols="12" md="6" lg="4">
                <strong>{{ $t('title.url') }}:</strong> {{ logDetails.url }}
            </b-col>
            <b-col cols="12" md="6" lg="4">
                <strong>{{ $t('title.method') }}:</strong> {{ logDetails.method }}
            </b-col>
            <b-col cols="12" md="6" lg="4">
                <strong>{{ $t('title.status_code') }}:</strong> {{ logDetails.status_code }}
            </b-col>
            <b-col cols="12" md="6" lg="4">
                <strong>{{ $t('title.service_id') }}:</strong> {{ logDetails.service_id }}
            </b-col>
            <b-col cols="12" md="6" lg="4">
                <strong>{{ $t('title.user_id') }}:</strong> {{ logDetails.user_id }}
            </b-col>
            <b-col cols="12" md="6" lg="4">
                <strong>{{ $t('title.created_at') }}:</strong> {{ formatDate(logDetails.created_at) }}
            </b-col>
            <b-col cols="12">
                <strong>{{ $t('title.request_payload') }}:</strong>
                <pre>{{ formattedJson(logDetails.request_payload) }}</pre>
            </b-col>
            <b-col cols="12">
                <strong>{{ $t('title.response_payload') }}:</strong>
                <pre>{{ formattedJson(logDetails.response_payload) }}</pre>
            </b-col>
        </b-row>

    </div>
</template>


<script>
import axios from '@/axios';
import Breadcrumbs from "@/components/Breadcrumbs.vue";

export default {
    data() {
        return {
            logDetails: {},
            isLoading: true,
            errorMessage: null
        };
    },
    components: { Breadcrumbs },
    mounted() {
        this.fetchLogDetails();
    },
    methods: {
        async fetchLogDetails() {
            this.isLoading = true;
            const logId = this.$route.params.id;

            try {
                const response = await axios.get(`admin/Api-Logs/${logId}`);
                this.logDetails = response.data.data;
            } catch (error) {
                console.error("API call error:", error);
                this.errorMessage = error.response ? error.response.data.message : error.message;
            } finally {
                this.isLoading = false;
            }
        },
        formatDate(dateString) {
            if (!dateString) return "-";
            return new Date(dateString).toLocaleString();
        },
        formattedJson(jsonString) {
            try {
                return JSON.stringify(JSON.parse(jsonString), null, 2);
            } catch {
                return jsonString || "-";
            }
        },
        goBack() {
            this.$router.go(-1);
        }
    }
};
</script>

<style scoped>
.header {
    flex-shrink: 0;
    display: flex;
    justify-content: space-between;
    padding: 10px;
}

.main-block {
    height: auto;
    min-height: 100%;
}


.details-container {
    background: #f8f9fa;
    padding: 10px;
    border-radius: 10px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    margin: 0;
    min-height: 400px;
    width: 100%;
}

pre {
    border-radius: 5px;
    white-space: pre-wrap;
    word-break: break-word;
    border: 1px solid #ddd;
    padding: 10px;
    overflow-x: auto;
}
</style>
